module.exports = __webpack_public_path__ + "img/product5.8c927067.png";